export function S4() {
  // tslint:disable-next-line: no-bitwise
  return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
}

export function uuid() {
  return `${S4()}${S4()}-${S4()}-${S4()}-${S4()}-${S4()}${S4()}${S4()}`.toLowerCase();
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/lib/utils/uuid.ts